import { GraduationCap, Award } from "lucide-react";
import { BIO, MEMBERSHIPS } from "../../data/content";
import { MEDIA } from "../../data/media";
import { Reveal } from "../../lib/motion";

export const MeetFfyona = () => {
  return (
    <section id="about" className="relative py-24 lg:py-36 bg-cream" aria-labelledby="about-heading">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
        {/* Portrait */}
        <div className="lg:col-span-5">
          <div className="relative">
            <div className="overflow-hidden rounded-[2.5rem] shadow-float">
              <img
                src={MEDIA.portrait}
                alt="Ffyona Duncan, counsellor and clinical supervisor"
                loading="lazy"
                className="w-full h-[560px] object-cover object-[center_20%]"
              />
            </div>
            <div className="absolute -bottom-6 -right-4 lg:-right-8 rounded-3xl bg-white shadow-float px-6 py-5 border border-sage-light/40">
              <img src={MEDIA.mncps} alt="MNCPS Accredited member" className="h-14 w-auto" />
            </div>
          </div>
          <div className="mt-12 flex flex-wrap gap-2.5">
            {BIO.values.map((v) => (
              <span key={v} className="rounded-full bg-cream-100 border border-sage-light/50 px-4 py-2 text-sm text-ink-soft">
                {v}
              </span>
            ))}
          </div>
        </div>

        {/* Bio */}
        <div className="lg:col-span-7">
          <Reveal><p className="overline text-sage-dark mb-5">Meet Ffyona</p></Reveal>
          <Reveal delay={0.05}>
            <h2 id="about-heading" className="font-serif text-4xl sm:text-5xl lg:text-6xl text-ink leading-[1.05] tracking-tight">
              Hello, I'm Ffyona.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-xl text-ink leading-relaxed font-serif italic">{BIO.intro}</p>
          </Reveal>

          <div className="mt-6 space-y-4">
            {BIO.paragraphs.map((p, i) => (
              <Reveal key={i} delay={0.05 * i}>
                <p className="text-[1.02rem] text-ink-soft leading-relaxed">{p}</p>
              </Reveal>
            ))}
          </div>

          {/* Why I became a counsellor */}
          <Reveal delay={0.1}>
            <div className="mt-10 rounded-3xl bg-sage-dark text-cream p-8 lg:p-10">
              <p className="overline text-sage-light mb-4">Why I became a counsellor</p>
              <p className="font-serif text-2xl lg:text-3xl leading-snug">{BIO.whyIBecame}</p>
            </div>
          </Reveal>

          {/* Qualifications */}
          <Reveal delay={0.1}>
            <div className="mt-10 grid sm:grid-cols-2 gap-x-8 gap-y-4">
              <div className="flex items-center gap-2 mb-1">
                <GraduationCap size={18} className="text-sage-dark" strokeWidth={1.5} />
                <p className="overline text-sage-dark">Qualifications & training</p>
              </div>
              <span className="hidden sm:block" />
              {BIO.qualifications.map((q) => (
                <div key={q} className="flex items-start gap-2.5" data-testid="qualification-item">
                  <Award size={16} className="mt-1 text-warm shrink-0" strokeWidth={1.5} />
                  <span className="text-[0.95rem] text-ink-soft">{q}</span>
                </div>
              ))}
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <p className="mt-8 text-sm text-ink-muted">
              Professional memberships: {MEMBERSHIPS.join(" · ")}
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
